export default {
    route: {
        dashboard: "首页",
        i18n: "国际化",
        externalLink: "外链",
        profile: "个人中心",
        allCategories: "全部分类",
        homePage: "首页",
        listGoods: "商品中心",
        BusinessListings: "商户列表",
        beefMarket: "和牛品种",
        industrynews: "新闻中心",
        helpCenter: "帮助中心",
        community: "社区中心",
        liveCattle:'拍卖中心'
    },
    navbar: {
        dashboard: "首页",
        github: "项目地址",
        logOut: "退出登录",
        profile: "个人中心",
        theme: "换肤",
        size: "布局大小",
        welcome: "欢迎来到Glory Beef",
        register: "注册",
        mfregister: "免费注册",
        shopHome: "商城首页",
        myOrder: "我的订单",
        memberCenter: "会员中心",
        businessResidence: "商户入驻",
        businessBackground: "商户后台",
        shoppingCart: "购物车",
        signOut: "退出",
        followUs: "扫码关注我们",
        HourlyHotline: "小时服务热线",
        copyright: "版权所有",
        LeshuiBay: "Glory Beef",
        footBot: "粤ICP备18070029号",
        auction:"我的拍卖"
    },
    login: {
        title: "MY BODY",
        logIn: "登录",
        username: "账号",
        password: "密码",
        any: "随便填",
        thirdparty: "第三方登录",
        thirdpartyTips: "本地不能模拟，请结合自己业务进行模拟！！！",
        accountLogon: "账户登录",
        notAccount: "还没有账户？",
        registerNow: "立即注册",
        forgetPassword: "忘记密码",
        return: "返回",
        mailbox: "邮箱",
        checkingmailbox: "验证邮箱",
        inputuser: "请输入用户名",
        inputpassWord: "请输入密码",
        inputLoginInfo: "填写账户信息",
        CompleteRegistration: "完成注册",
        verification: "验证",
        newPassword: "新密码",
        repeatNewPassword: "重复新密码",
        clickVerify: "点击按钮进行验证",
        confirmPassword: "确认密码",
        registeredMailbox: "已注册邮箱",
        mailboxCode: "请输入邮箱验证码",
        mailboxInput: "请输入邮箱",
        retrieve: "重新获取",
        Consent: "注册代表同意",
        complete: "完成",
        getMailboxCode: "获取邮箱验证码",
        and: "和",
        fuwu: "《服务条款》",
        yinsi: "《隐私策略》",
        Pleasepassword: "请输入新密码",
        Pleaseagain: "请再次输入密码",
        loginsuccessful: "注册成功",
        Pleaselogin: "请登录",
        Previousstep: "上一步",
        nextstep: "下一步"
    },
    permission: {
        addRole: "新增角色",
        editPermission: "编辑权限",
        roles: "你的权限",
        switchRoles: "切换权限",
        tips:
            "在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。",
        delete: "删除",
        confirm: "确定",
        cancel: "取消"
    },
    table: {
        putTitle: "请输入标题",
        putTitleLengh: "长度在 1 到 100 个字符",
        putContext: "请输入话题内容",
        putContextLength: "长度在 1 到 1200 个字符",
        selectPhotoView: "请选择图片文本或者视频文本",
        dynamicTips1: "固定表头, 按照表头顺序排序",
        dynamicTips2: "不固定表头, 按照点击顺序排序",
        dragTips1: "默认顺序",
        dragTips2: "拖拽后顺序",
        title: "标题",
        importance: "重要性",
        type: "类型",
        remark: "点评",
        search: "搜索",
        add: "添加",
        export: "导出",
        reviewer: "审核人",
        id: "序号",
        date: "时间",
        author: "作者",
        readings: "阅读数",
        status: "状态",
        actions: "操作",
        edit: "编辑",
        publish: "发布",
        shenhe: "待审核",
        hasPublished: "已发布",
        reject: "被驳回",
        draft: "草稿",
        delete: "删除",
        cancel: "取 消",
        confirm: "确 定",
        completeImgs: "请填写内容",
    },
    excel: {
        export: "导出",
        selectedExport: "导出已选择项",
        placeholder: "请输入文件名(默认excel-list)"
    },
    zip: {
        export: "导出",
        placeholder: "请输入文件名(默认file)"
    },
    pdf: {
        tips: "这里使用   window.print() 来实现下载pdf的功能"
    },
    theme: {
        change: "换肤",
        documentation: "换肤文档",
        tips:
            "Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。"
    },
    tagsView: {
        refresh: "刷新",
        close: "关闭",
        closeOthers: "关闭其它",
        closeAll: "关闭所有"
    },
    settings: {
        title: "系统布局配置",
        theme: "主题色",
        tagsView: "开启 Tags-View",
        fixedHeader: "固定 Header",
        sidebarLogo: "侧边栏 Logo"
    },
    // 公共
    common: {
        bookmark: "收藏店铺",
        selfSupport: "自营",
        currentLocation: "当前所在位置",
        number: "数量",
        stock: "库存",
        commodity: "商品",
        specifications: "规格",
        price: "价格",
        subtotal: "小计",
        operation: "操作",
        TotalPrice: "总额",
        unitPrice: "单价",
        beStock: "be out of stock",
        delete: "删除",
        productCode: "商品编码",
        productSpecifications: "商品规格",
        empty: "这里空空如也",
        goodsOffShelf: "商品已下架",
        outOfStock: "缺货",
        insufficientInventory: "库存不足",
        operation: "操作中",
        loading: "加载中",
        noItemSelected: "没有选中商品！",
        successCollection: "收藏成功",
        collectionCancelled: "已取消收藏",
        default: "默认",
        isDeleteAddress: "确定删除收货地址?",
        Tips: "提示",
        SuccessDeleted: "删除成功！",
        DeleteFailed: "删除失败！",
        SuccessModified: "修改成功",
        date: "日期",
        createTime: "创建时间",
        updateTime: "更新时间",
        title:"标题",
        like:"点赞" ,
        send:"发送",
        contactUs:"联系我们"
    },
    // 首页
    home: {
        merchants: "商户",
        hotSearches: "热门搜索",
        HistoricalSearch: "历史搜索",
        viewMore: "查看更多",
        preferredMerchants: "优选商家",
        preferredMerchantsSubTit: "口碑好店，无限回购",
        HourServiceHotline: "小时服务热线："
    },
    // 商品详情页
    goodsDetail: {
        commodityDetailsPage: "商品详情页",
        purchasePrice: "采购价",
        cumulativeSales: "累计销量",
        buyNow: "立即购买",
        bidNow: "立即出价",
        addToCart: "加入购物车",
        commodityInfo: "商品信息",
        shoppingCartSucAdd: "已成功添加购物车"
    },
    // 商品列表
    goodsList: {
        allProducts: "全部商品",
        ProductList: "商品列表",
        ProductScreening: "商品筛选",
        itemsTotal: "件商品",
        common: "共",
        selected: "您已选择",
        comprehensive: "综合",
        salesvolume: "销量",
        price: "价格",
        multipleChoice: "多选"
    },
    // 购物车
    shopCart: {
        cartEmpty: "你的购物车空空如也",
        purchase: "快去选购吧",
        recommended: "为你推荐",
        deleteSelected: "删除选中商品",
        selected: "已选择",
        totalPrice: "总价",
        toSettle: "去结算",
        settleProgress: "结算中",
        selectedItems1: "已选择",
        selectedItems2: "件商品"
    },
    // 订单
    order: {
        TakeProduct: "拍下商品",
        fillOrderInfo: "填写核对订单信息",
        SuccessSubmittOrder: "成功提交订单",
        fillOrderInfo: "填写并核对订单信息",
        addAddress: "新增收货地址",
        defaultAddress: "默认地址",
        noAddress: "暂无地址",
        moreAddresses: "更多地址",
        receiveAddress: "收起地址",
        goBrowsing: "去逛逛",
        ProductQuantity: "商品数量",
        submit: "提交",
        pleaseEnterContent: "请输入内容",
        addEditAddress: "新增/编辑地址",
        consignee: "收货人",
        pleaseEnterRecipient: "请输入收货人",
        contactNumber: "联系电话",
        phoneNumber: "11位手机号",
        address: "收货地址",
        default: "设为默认",
        save: "保存",
        orderSuccessUpload: "订单提交成功，请您尽快上传支付凭证！",
        orderNumber: "订单号",
        TotalOrderAmount: " 订单总额",
        actualPayment: "商品实付",
        contactInfo: "联系方式",
        uploadCredentials: "去支付",
        cancelOrder: "取消订单",
        cancel: "取消",
        determine: "确定",
        cancelThisOrder: "是否取消此订单",
        uncanceledOrders: "未取消订单",
        canceledSuccess: "取消成功",
        viewOrder: "查看订单",
        ViewAllOrders: "查看全部订单",
        allOrders: "全部订单",
        toBeUploaded: "待上传凭证",
        toBeShipped: "待发货",
        Audit: "待审核",
        toBeReceived: "待收货",
        completed: "已完成",
        shipped: "已发货",
        viewDetails: "查看详情",
        orderTime: "下单时间",
        orderAmount: "订单总额",
        enterOrderNumber: "请输入订单编号查询",

        myOrder: "我的订单",
        billingAccount: "下单账号",
        addressee: "收件人",
        orderRemarksInfo: "订单备注信息",
        noData: "暂无数据",
        orderExpired: "该订单已失效",
        orderCancelled: "该订单已取消",
        OrderInformation: "订单信息",
        ItemSKU: "商品编号",
        common: "共",
        Total: "共",
        yuan: "元",
        piece: "件",
        tip1: "订单获取失败！",
        tip2: "当前订单金额为0，请继续采购！",
        tip3: "订单支付信息缺失！",
        tip4: "收货地址未填写！",
        addressErr1: "填写格式有误",
        addressErr2: "请输入收货人姓名！",
        addressErr3: "请输入有效的收货人姓名！",
        addressErr4: "请输入11位有效手机号码！",
        addressErr5: "请输入11位有效手机号码！",
        addressErr6: "手机号格式不正确！",
        addressErr7: "请输入地址！",
        addressErr8: "详细地址过长，请重新输入！",
        actualPayment: "实付",
        totalPayment: "总付款",
        orderStatus1: "支付凭证已上传，待审核~",
        orderStatus2: "审核已完成，待发货~",
        orderStatus3: "已发货~",
        uploadVoucher: "请上传凭证",
        uploadSuccess: "上传成功",
        orderNumber2:"单据号",
        productName:"商品名称",
        purchaseTime:"购买时间",
        seller:"卖家",
        sellerPhone:"卖家电话",
        sellerEmail:"卖家邮箱",
        sellerAddress:"卖家地址",
        mode:"模式",
    },
    // 个人中心
    profile: {
        address: "地址",
        myCollection: "我的收藏",
        orderManagement: "订单管理",
        goodsCollection: "商品收藏",
        storeCollection: "店铺收藏",
        cancelCollection: "取消收藏",
        created: "您已创建 ",
        receiptAddresses: " 个收货地址,",
        upTo10: "最多可创建",
        ge: "个",
        addAddress: "新增地址",
        isCancelCol: "确定取消收藏？",
        lookOther: "看看别的",

        community: "个人社区",
    },
    // 商户
    Merchant: {
        PeopleCollections: "人收藏",
        ComeLook: "进店看看",
        Favorite: "已收藏",
        CollectionStore: "收藏店铺"
    },
    Settlein: {
        Storestatus: "店铺状态",
        Auditfailed: "审核失败",
        Normaloperations: "正常营业",
        ViolatingClearance: "违规关团",
        username: "用户名:",
        email: "邮箱为登录邮箱",
        ContactName: "联系人姓名:",
        phonenumber: "联系人手机号",
        StoreName: "门店名称",
        StoreIntroduction: "店铺简介",
        Detailedaddress: "详细地址",
        tips1: "请上传店铺Logo，单张照片不超过2M，支持jpg，png格式",
        Pleaselogo: "请上传店铺Logo",
        storelogo: "店铺Logo",
        Businesslicense: "营业执照",
        tips2: "请提供营业执照，单张照片不超过2M，支持jpg，png格式",
        PleaseLicense: "请上传您的营业执照",
        haveagree: "我已阅读并同意",
        MerchantAgreement: "商家入驻协议"
    },
    prompt: {
        passwordTips1: "邮箱格式不正确！",
        passwordTips2: "获取邮箱验证码",
        passwordTips3: "邮箱格式不正确！",
        passwordTips4: "请输入邮箱验证码！",
        passwordTips5: "请输入密码！",
        passwordTips6: "密码长度6~16位！",
        passwordTips7: "两次密码输入不一致！"
    },
    community: {
        postTopic: "欢迎发表话题",
        enterTitle: "请输入一个标题",
        ImageText:"图片文本",
        viedoText: "视频文本！",
        title:"话题标题",
        content: "话题内容",
        rest:"重置",
        release:"发布",
        fiveAll:"最多上传5张图片",
        oneViedo:"最多上传一份视频,不可超过50MB",
        viedoUp:"视频上传"
    }
};
